/**
 * 控制台输出封装
 */
/**
 * 控制台输出警告信息
 * @param msg
 */
export function warn(msg) {
    console.warn("%c [@tencent/vb-web-base] ".concat(msg), 'background: #625408; color: #FFE037');
}
